import { minBy, sumBy } from 'lodash-es';
import { DateTime } from 'luxon';
import { createSubscriptionModel, SubscriptionModel } from './createSubscriptionModel';
import { sortSubscriptionModelFn } from './sortSubscriptionModelFn';
import { ProductName, Subscription } from './types';

type LicenseStatus = 'active' | 'expired';

export interface LicenseModel {
  status: LicenseStatus;
  key: string;
  licenseType: ProductName;
  subscriptions: SubscriptionModel[];
  seats: number;
  id: string;
  creationDate: DateTime;
}

const activeStatuses: Array<SubscriptionModel['status']> = ['active', 'canceled', 'altered'];

export const createLicenseModel = (
  licenceId: string,
  originalSubscriptions: Subscription[] = [],
): LicenseModel => {
  const subscriptionsModels = originalSubscriptions.map(createSubscriptionModel);
  subscriptionsModels.sort(sortSubscriptionModelFn);
  const status = subscriptionsModels.some((s) => activeStatuses.includes(s.status))
    ? 'active'
    : 'expired';
  const seats = sumBy(
    subscriptionsModels.filter((s) => s.status !== 'expired'),
    'seats',
  );
  const creationDate =
    minBy(subscriptionsModels, (s) => s.serviceActivationDate.toMillis())?.serviceActivationDate ||
    DateTime.fromISO('1970-01-01');

  return {
    id: licenceId,
    subscriptions: subscriptionsModels,
    key: subscriptionsModels[0]?.licenseKey,
    licenseType: subscriptionsModels[0]?.licenseType,
    status,
    seats,
    creationDate,
  };
};
